// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  Z-index Tokens
******************************/
:root {
  --m-z-index-sticky: 1020;
  --m-z-index-fixed: 1030;
  --m-z-index-modal-backdrop: 1040;
  --m-z-index-offcanvas: 1050;
  --m-z-index-modal: 1060;
  --m-z-index-mask: 1061;
  --m-z-index-dropdown: 1062;
  --m-z-index-popover: 1070;
  --m-z-index-tooltip: 1080;
  --m-z-index-lazy-load: 1090;
  /* Above every overlay, including ad-hoc 9999/10100 layers */
  --m-z-index-toast: 11000;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_z-index.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGC;EACG,wBAAA;EACA,uBAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4DAAA;EACA,wBAAA;AACJ","sourcesContent":["/******************************\n*  Z-index Tokens\n******************************/\n :root {\n    --m-z-index-sticky: 1020;\n    --m-z-index-fixed: 1030;\n    --m-z-index-modal-backdrop: 1040;\n    --m-z-index-offcanvas: 1050;\n    --m-z-index-modal: 1060;\n    --m-z-index-mask: 1061;\n    --m-z-index-dropdown: 1062;\n    --m-z-index-popover: 1070;\n    --m-z-index-tooltip: 1080;\n    --m-z-index-lazy-load: 1090;\n    /* Above every overlay, including ad-hoc 9999/10100 layers */\n    --m-z-index-toast: 11000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
